import { Route, Switch, Redirect } from "react-router-dom";
import { notification } from "antd";
import custom from "../utils/custom";
import axios from "../utils/axios";
import { setStore } from "../utils/global";
import ForgotPass from "./login/ForgotPass";
import MobileLogin from "./login/MobileLogin";
import EmailLogin from "./login/EmailLogin";
import { useMutation } from "react-query";

const LoginRoute = () => {
  const hostname = window.location.hostname;
  const isUnitel = hostname === "unitel.vsign.mn";
  const isTest = hostname === "vms.vsign.mn";

  const { mutate: login, isLoading: isLoginLoading } = useMutation({
    mutationKey: "login",
    mutationFn: (formData) => axios.post("/client/auth/login", formData, { showErrorMessage: true, showSuccessMessage: true }),
    onSuccess: ({ success, data }) => {
      if (success) {
        custom.setCookie("token", data.token);
        let red = custom.getCookie("redirect_url");
        custom.setCookie("redirect_url", "");
        setStore("user", data.detail);
        if (red && window.location.hash !== red) {
          window.location.hash = red;
        } else {
          window.location.hash = "#/home";
        }
      }
    },
  });

  const onsubmit = (json) => {
    custom.setCookie("provider", json.provider);

    if (json.type !== "mobile") {
      if (!json.captcha) {
        notification.error({
          message: "Анхаар!",
          description: "Би робот биш товч дээр дарна уу.",
          duration: 2,
        });
        return;
      }
    }

    login(json);
  };

  return (
    <div className="login_container">
      <div className="login">
        <div style={{ textAlign: "center" }}>
          <img className="login_image" src="./logo.png" alt="logo" />
          <b className="header_logo_name">VSIGN</b>
          {isUnitel && <img src="/unitel.svg" alt="unitel" style={{ marginLeft: 30, height: 30 }} />}
          {isTest && <b style={{ marginLeft: 30, fontSize: 16 }}>Test server</b>}
        </div>
        <div className="login_form">
          <Switch>
            <Route path="/login/email">
              <div className="login_title">Please log in to your VSign account</div>
              <EmailLogin onsubmit={onsubmit} isLoading={isLoginLoading} />
            </Route>
            <Route path="/login/mobile">
              <div className="login_title">Please log in to your VSign account</div>
              <MobileLogin onsubmit={onsubmit} isLoading={isLoginLoading} />
            </Route>
            <Route path="/login/forgot">
              <div className="login_title">Please enter your email address.</div>
              <ForgotPass />
            </Route>
            <Redirect to="/login/email" />
          </Switch>
        </div>
      </div>
      <div className="login_footer">VSign.mn © 2021, Inc. All rights reserved</div>
    </div>
  );
};

export default LoginRoute;
